import { creatContextStore } from './base';
import { userIsAuthorized } from 'actions/authActions';

export interface AppInfo {
  Authenticated?: boolean; 
  Authenticating?: boolean;
};

let initialUserAuth: boolean = false;
if (userIsAuthorized) {
  initialUserAuth = userIsAuthorized();
}
const initialState = {
  Authenticated: initialUserAuth,
  Authenticating: false,
};

const [ Provider, useState, useSetState, useMergeState ] = creatContextStore<AppInfo>(initialState);

export {
  Provider as AppContextProvider,
  useState as useAppState,
  useSetState as useSetAppState,
  useMergeState as useMergeAppState,
};
